var React = require('react');

function SocialTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M389.2 48h70.6L305.6 224.2L487 464H345L233.7 318.6L106.5 464H35.8l164.9-188.5L26.8 48h145.6l100.5 132.9zm-24.8 373.8h39.1L151.1 88h-42z"}));
}

SocialTwitter.defaultProps = {"width":"32","height":"32","viewBox":"0 0 512 512"};

module.exports = SocialTwitter;

SocialTwitter.default = SocialTwitter;
